export const prependWithZero = (num) => (num <= 9 ? `0${num}` : String(num));
